export default __webpack_public_path__ + "static/media/25-burns.b8e0f588.png";